import * as TP from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetConnectCarrierTenderCarrierPortalCountQueryVariables = TP.Exact<{
  filter?: TP.InputMaybe<TP.TenderCarrierPortalFilterInput>;
}>;


export type GetConnectCarrierTenderCarrierPortalCountQuery = (
  { readonly __typename?: 'Query' }
  & { readonly getConnectCarrierTenderCarrierPortalCount: (
    { readonly __typename?: 'TenderCarrierPortalCountResult' }
    & Pick<TP.TenderCarrierPortalCountResult, 'count'>
    & { readonly errors?: TP.Maybe<ReadonlyArray<(
      { readonly __typename?: 'CarrierConnectError' }
      & Pick<TP.CarrierConnectError, 'message' | 'code' | 'errorType'>
    )>> }
  ) }
);


export const GetConnectCarrierTenderCarrierPortalCountDocument = gql`
    query GetConnectCarrierTenderCarrierPortalCount($filter: TenderCarrierPortalFilterInput) {
  getConnectCarrierTenderCarrierPortalCount(filter: $filter) {
    count
    errors {
      message
      code
      errorType
    }
  }
}
    `;

/**
 * __useGetConnectCarrierTenderCarrierPortalCountQuery__
 *
 * To run a query within a React component, call `useGetConnectCarrierTenderCarrierPortalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectCarrierTenderCarrierPortalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectCarrierTenderCarrierPortalCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetConnectCarrierTenderCarrierPortalCountQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectCarrierTenderCarrierPortalCountQuery, GetConnectCarrierTenderCarrierPortalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectCarrierTenderCarrierPortalCountQuery, GetConnectCarrierTenderCarrierPortalCountQueryVariables>(GetConnectCarrierTenderCarrierPortalCountDocument, options);
      }
export function useGetConnectCarrierTenderCarrierPortalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectCarrierTenderCarrierPortalCountQuery, GetConnectCarrierTenderCarrierPortalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectCarrierTenderCarrierPortalCountQuery, GetConnectCarrierTenderCarrierPortalCountQueryVariables>(GetConnectCarrierTenderCarrierPortalCountDocument, options);
        }
export type GetConnectCarrierTenderCarrierPortalCountQueryHookResult = ReturnType<typeof useGetConnectCarrierTenderCarrierPortalCountQuery>;
export type GetConnectCarrierTenderCarrierPortalCountLazyQueryHookResult = ReturnType<typeof useGetConnectCarrierTenderCarrierPortalCountLazyQuery>;
export type GetConnectCarrierTenderCarrierPortalCountQueryResult = Apollo.QueryResult<GetConnectCarrierTenderCarrierPortalCountQuery, GetConnectCarrierTenderCarrierPortalCountQueryVariables>;